import block from 'propmods';
import React, { SFC } from 'react';
import { Switch, Route } from 'react-router';
import * as keyset from 'i18n/GeneralSettings';
import i18n from '@yandex-int/i18n';
import { Page } from '../Typo/Typo';
import Footer from '../Footer/Footer';
import { routes } from '../../lib/routes';
import GeneralSettings from '../GeneralSettings/GeneralSettings';
import Menu from '../Menu/Menu';

import './AppSettingsPage.scss';

const t = i18n(keyset);
const b = block('AppSettingsPage');

const AppSettingsPage: SFC = () => {
    const menuItems = [
        {
            path: routes.app.settings(),
            title: t('tab-title-general-settings'),
            exact: true,
        },
    ];

    return (
        <Page>
            <Page.Head>
                <Page.HeadContent>
                    <h1 {...b('headline')}>{t('header-settings')}</h1>
                    <div {...b('nav')}>
                        <Menu items={menuItems} />
                    </div>
                </Page.HeadContent>
            </Page.Head>
            <Page.Content>
                <Page.Page>
                    <Switch>
                        <Route exact path={routes.app.settings()} render={() => <GeneralSettings />} />
                    </Switch>
                </Page.Page>
            </Page.Content>
            <Footer feedback={routes.documentation.aliceSkills.feedback} />
        </Page>
    );
};

export default AppSettingsPage;
